// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var Behavior;
(function (Behavior) {
    Behavior[Behavior["Gainer"] = 0] = "Gainer";
    Behavior[Behavior["Loser"] = 1] = "Loser";
})(Behavior || (Behavior = {}));
